import { InjectionToken } from '@angular/core';
import { IConfiguration } from '@mds/angular-core-material';
import { IToolbarLogo } from '@mds/angular-layout-material';
import { ReplaySubject } from 'rxjs';

export function getApiBaseUrl(): string {
  if (/localhost:4300/.test(window.location.origin)) {
    return 'https://localhost:44335';
  } else if (/tvptest/.test(window.location.origin) || /dev.appointment.planzer.app/.test(window.location.origin)) {
    return 'https://api.tvptest.planzergroup.com';
  } else {
    return 'https://api.tvp.planzergroup.com';
  }
}

export function getApiConfigUrl(): string {
  return `${getApiBaseUrl()}/config`;
}

export const toolbarLogo: IToolbarLogo = {
  alt: 'Planzer',
  src: './assets/images/planzer.png',
  title: 'Planzer',
};

export const TVP_TOOLBAR_LOGO = new InjectionToken<ReplaySubject<string>>('toolbar logo');

export interface ITvpConfiguration extends IConfiguration {
  supportOptions: {
    email: string;
    phone: string;
  };
  recaptchaOptions: {
    siteKey: string;
  };
}
